import type { ErrorResponse, MutationParam } from 'viewup-lib/common';
import { useSDMutation } from 'viewup-lib/react';
import {
  type ToggleActiveSnsAccountReq,
  toggleActiveSnsAccount,
} from './mapper/toggleActiveSnsAccount';

export const useToggleActiveSnsAccount = (
  params?: MutationParam<unknown, ErrorResponse, ToggleActiveSnsAccountReq>,
) => {
  return useSDMutation<unknown, ErrorResponse, ToggleActiveSnsAccountReq>({
    ...params?.options,
    mutationFn: toggleActiveSnsAccount,
  });
};
